import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { Box } from '@mentimeter/ragnar-ui/box';
import { getNinePointLayoutProperties } from '../../shared/utils/getNinePointLayoutProperties';
import { ContentSlideTitleSection } from '../../shared/components/ContentSlideTitleSection';
import { StaggerCss } from '../../shared/components/StaggerCss';
import { Steps } from './Steps';
import fontOffset from './fontOffset';

export function BulletsPresentation() {
  const { useQuestion, useConfig, usePace } = usePresentationContext();

  const {
    question,
    title_meta,
    layout,
    choices,
    show_all_bullets: showAllBullets,
    numbered_list: isNumberedList,
    cropped_image_url: image,
  } = useQuestion();

  const { step } = usePace();
  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(layout);
  const { mode, enableAnimations } = useConfig();

  // Copy of breakpoints from packages/sfinx/src/renderers/content/bullets/bullets.tsx
  const breakpoints = [
    { count: 1600, offset: -6 }, // Handling very content rich lists
    { count: 600, offset: -4 },
    { count: 400, offset: -3 },
    { lineCount: 25, offset: -6 },
    { lineCount: 16, offset: -5 },
    { lineCount: 14, offset: -3 },
    { lineCount: 12, offset: -2 },
    { lineCount: 6, offset: -1 },
  ];
  const maxWidth = choices
    .map((s) => s.label.length)
    .reduce((curr, next) => Math.max(curr, next), 75); // Handle if we have no steps

  const width = image ? Math.min(75, maxWidth) : Math.min(130, maxWidth);
  const height = choices
    .map((s) => s.label.length)
    .reduce(
      (curr, next) => curr + Math.ceil(next / width),
      Math.ceil(question.length / width),
    );
  const offset =
    fontOffset({ width, height, breakpoints }) +
    (layout?.font_size_offset ?? 0);

  return (
    <Box
      width="100%"
      alignItems={alignItems}
      justifyContent={justifyContent}
      data-testid="bullets-container"
    >
      <ContentSlideTitleSection
        question={question}
        title_meta={title_meta}
        layout={layout}
        textAlign={textAlign}
        alignItems={alignItems}
        enableAnimations={true}
        justifyContent="flex-end"
        mb="space4"
      />
      <StaggerCss
        flex="auto"
        width="auto"
        index={2}
        type="fade"
        enableAnimations={enableAnimations}
      >
        <Steps
          fontOffset={offset - 1}
          enableAnimations={enableAnimations}
          step={step}
          steps={choices}
          showAllSteps={
            showAllBullets || mode === 'screenshot' || mode === 'public'
          }
          numberedListEnabled={isNumberedList}
        />
      </StaggerCss>
    </Box>
  );
}
